module.exports = __webpack_public_path__ + "img/testimonial-marika-fleri.6f1c6d3e.png";